import React from "react";

import { Company } from "../Company/Company";
import { Invoice } from "../Billing/Billing";

import { LicenseStatusEnum } from "../../Utilities/Enums/StatusEnums";
import { LicenseField, LicenseListField, BuyLicensePackageField, BuyLicenseField, LicenseDetailsBuyField, GenerateLicenseField } from '../../Utilities/Enums/ParametersEnum';
import { ValidityTypeEnum } from '../../Utilities/Enums/ValidityTypeEnums';

export class License {
    [LicenseField.BILLING_DETAILS]?: LicenseGenerateBillingDetails = new LicenseGenerateBillingDetails();
    [LicenseField.COMPANY]?: Company = new Company();
    [LicenseField.COMPANY_NAME]?: string = "";
    [LicenseField.COMPANY_PUBLIC_ID]?: string | number | null = null;
    [LicenseField.CREATED_DATE]?: string | Date | null = null;
    [LicenseField.EXPIRY_DATE]?: string | Date | null = null;
    [LicenseField.ISSUE_DATE]?: string | Date | null = null;
    [LicenseField.LICENSE_KEY]?: string = "";
    [LicenseField.LICENSE_TYPE]?: number = 0;
    [LicenseField.MODULES]?: string[] = [];
    [LicenseField.PUBLIC_ID]?: string | number = "";
    [LicenseField.STATUS]?: LicenseStatusEnum = 0;
    [LicenseField.STORAGE_CAPACITY]?: number = 0;
    [LicenseField.STORAGE_USED]?: number = 0;
    [LicenseField.UPDATED_DATE]?: string | Date | null = null;
    [LicenseField.USER_CAPACITY]?: number = 0;
    [LicenseField.USER_SLOT_USED]?: number = 0;
    [LicenseListField.VALIDITY]: number = 0;
    [LicenseListField.VALIDITY_TYPE]: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [LicenseListField.INVOICE_EXISTS]?: boolean = false;

    constructor(obj?: Partial<License>) {
        Object.assign(this, obj);
    }
}

export class LicenseList {
    [LicenseListField.COMPANY_NAME]: string = "";
    [LicenseListField.COMPANY_PUBLIC_ID]?: string | number = "";
    [LicenseListField.ISSUE_DATE]?: string | Date | null = null;
    [LicenseListField.EXPIRY_DATE]?: string | Date | null = null;
    [LicenseListField.LICENSE_KEY]?: string = "";
    [LicenseListField.LICENSE_TYPE]?: number = 0;
    [LicenseListField.PUBLIC_ID]?: string | number = "";
    [LicenseListField.STATUS]?: LicenseStatusEnum = 0;
    [LicenseListField.STORAGE_CAPACITY]: number = 0;
    [LicenseListField.STORAGE_USED]: number = 0;
    [LicenseListField.USER_CAPACITY]: number = 0;
    [LicenseListField.USER_SLOT_USED]: number = 0;
    [LicenseListField.VALIDITY]: number = 0;
    [LicenseListField.VALIDITY_TYPE]: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [LicenseListField.INVOICE_EXISTS]?: boolean = false;
    [LicenseListField.CREATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<LicenseList>) {
        Object.assign(this, obj);
    }
}

export class PackageBuyLicense {
    [BuyLicensePackageField.PUBLIC_ID]?: string | number = "";
    [BuyLicensePackageField.LICENSE_TYPE]?: number = 0;
    [BuyLicensePackageField.LICENSE_PACKAGE]?: number = 0;
    [BuyLicensePackageField.ADD_ON]?: string | number = "";
    [BuyLicensePackageField.VALIDITY_IN_YRS]: number = 0;
    [BuyLicensePackageField.EXPIRY_DATE]?: string | Date | null = null;
    [BuyLicensePackageField.ISSUE_DATE]?: string | Date | null = null;
    [BuyLicensePackageField.COMPANY_NAME]?: string = "";
    [BuyLicensePackageField.COMPANY_PUBLIC_ID]?: string | number = "";

    [BuyLicensePackageField.SUB_TOTAL]?: number = 0;
    [BuyLicensePackageField.DISCOUNT_AMOUNT]?: number = 0;
    [BuyLicensePackageField.TAX_PERCENT]?: number = 8;
    [BuyLicensePackageField.TAX_AMOUNT]?: number = 0;
    [BuyLicensePackageField.GRAND_TOTAL]?: number = 0;

    constructor(obj?: Partial<PackageBuyLicense>) {
        Object.assign(this, obj);
    }
}

export class LicenseBuy {
    [BuyLicenseField.INVOICE]?: Invoice = new Invoice();
    [BuyLicenseField.LICENSE_DETAILS]?: LicenseDetailsBuy = new LicenseDetailsBuy();
    [BuyLicenseField.TRANSACTION_KEY]?: string = "";


    constructor(obj?: Partial<LicenseBuy>) {
        Object.assign(this, obj);
    }
}

export class LicenseDetailsBuy {
    [LicenseDetailsBuyField.LICENSE_TYPE]?: number = 0;
    [LicenseDetailsBuyField.STORAGE_CAPACITY]?: number = 0;
    [LicenseDetailsBuyField.USER_CAPACITY]?: number = 0;
    [LicenseDetailsBuyField.VALIDITY]?: number = 0;
    [LicenseDetailsBuyField.VALIDITY_TYPE]?: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [LicenseDetailsBuyField.ISSUE_DATE]?: string | Date | null = null;
    [LicenseDetailsBuyField.EXPIRY_DATE]?: string | Date | null = null;
    [LicenseDetailsBuyField.COMPANY_PUBLIC_ID]?: string | number | null = null;
    [LicenseDetailsBuyField.STATUS]?: LicenseStatusEnum = LicenseStatusEnum.UNUSED;
    [LicenseDetailsBuyField.MODULES]?: string[] = [];
    [LicenseDetailsBuyField.BILLING_DETAILS]?: LicenseGenerateBillingDetails = new LicenseGenerateBillingDetails();
    
    constructor(obj?: Partial<LicenseDetailsBuy>) {
        Object.assign(this, obj);
    }
}

export class LicenseGenerate {
    [GenerateLicenseField.PUBLIC_ID]?: string | number = "";
    [GenerateLicenseField.LICENSE_TYPE]?: number = 0;

    [GenerateLicenseField.STORAGE_CAPACITY]: number = 0;
    [GenerateLicenseField.STORAGE_USED]: number = 0;
    [GenerateLicenseField.USER_CAPACITY]: number = 0;
    [GenerateLicenseField.USER_SLOT_USED]: number = 0;
    [GenerateLicenseField.VALIDITY]: number = 0;
    [GenerateLicenseField.VALIDITY_TYPE]: ValidityTypeEnum = ValidityTypeEnum.MONTH;
    [GenerateLicenseField.EXPIRY_DATE]?: string | Date | null = null;
    [GenerateLicenseField.ISSUE_DATE]?: string | Date | null = null;
    [GenerateLicenseField.COMPANY_NAME]?: string = "";
    [GenerateLicenseField.COMPANY_PUBLIC_ID]?: string | number | null = null;
    [GenerateLicenseField.STATUS]?: LicenseStatusEnum = 0;

    [GenerateLicenseField.MODULES]?: string[] = [];
    [GenerateLicenseField.BILLING_DETAILS]?: LicenseGenerateBillingDetails = new LicenseGenerateBillingDetails();

    constructor(obj?: Partial<LicenseGenerate>) {
        Object.assign(this, obj);
    }
}

export class LicenseGenerateBillingDetails {
    [GenerateLicenseField.SUB_TOTAL]?: number = 0;
    [GenerateLicenseField.TAX_RATE]?: number = 0;
    [GenerateLicenseField.TAX_AMOUNT]?: number = 0;
    [GenerateLicenseField.TOTAL_AMOUNT]?: number = 0;
    [GenerateLicenseField.IS_WITH_ANNUAL_DISCOUNT]?: boolean = false;
    [GenerateLicenseField.DISCOUNT_APPLIED]?: boolean = false;
    [GenerateLicenseField.NOTES]?: string = '';
    [GenerateLicenseField.DISCOUNT_AMOUNT]?: number = 0;

    constructor(obj?: Partial<LicenseGenerate>) {
        Object.assign(this, obj);
    }
}

export class IssueLicenseModalInterface {
    openIssueLicenseModal?: boolean;
    setopenIssueLicenseModal?: React.Dispatch<React.SetStateAction<boolean>>;
    licensePublicId?: string | number;
    getCompanyData?: () => void = () =>{};


    constructor(obj?: Partial<IssueLicenseModalInterface>) {
        Object.assign(this, obj);
    }
}

export class GeneratedLicenseInvoiceModalInterface {
    openGeneratedInvoiceModal?: boolean;
    setopenGeneratedInvoiceModal?: React.Dispatch<React.SetStateAction<boolean>>;
    generatedInvoicePublicId?: any;
    setgeneratedInvoicePublicId?: React.Dispatch<React.SetStateAction<any>>;
    generatedInvoiceNo?: any;
    setgeneratedInvoiceNo?: React.Dispatch<React.SetStateAction<any>>;
}

export class LicenseModulesInterface {
    modules?: any = [];
    isTableOnly?: boolean = false;

    constructor(obj?: Partial<LicenseModulesInterface>) {
        Object.assign(this, obj);
    }
}

